export var FetchLevel;
(function (FetchLevel) {
    FetchLevel["PER_USER"] = "PER_USER";
    FetchLevel["PER_TENANT"] = "PER_TENANT";
    FetchLevel["PER_WORLD"] = "PER_WORLD";
})(FetchLevel || (FetchLevel = {}));
export var DataScope;
(function (DataScope) {
    DataScope["STAR"] = "STAR";
    DataScope["USER"] = "USER";
})(DataScope || (DataScope = {}));
export var ProviderName;
(function (ProviderName) {
    ProviderName["LEGACY"] = "LEGACY";
    ProviderName["MIGRATION"] = "MIGRATION";
    ProviderName["DEBBIE"] = "DEBBIE";
    ProviderName["AKS"] = "AKS";
    ProviderName["CVR"] = "CVR";
    ProviderName["TINGBOGEN"] = "TINGBOGEN";
    ProviderName["MAILVALIDATOR"] = "MAILVALIDATOR";
    ProviderName["COURT"] = "COURT";
    ProviderName["VONAGE"] = "VONAGE";
    ProviderName["CPR"] = "CPR";
    ProviderName["EJF"] = "EJF";
})(ProviderName || (ProviderName = {}));
//# sourceMappingURL=index.js.map